export default "__VITE_PUBLIC_ASSET__5648a133__"